// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__jczXA","dragIcon":"Choice_dragIcon__2s1Bv","left":"Choice_left__23H9-","input":"Choice_input__c86T6"};